import { Formik, FormikHelpers } from "formik";
import {
  ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse,
  useFormSubmit,
} from "melco-shared-logic";
import { useQueryClient } from "react-query";
import { DirtyFormPrompt } from "../../../../form/DirtyFormPrompt";
import { DisplayChangeMachineLicensesForm } from "./DisplayChangeMachineLicensesForm";
import { useChangeMachineLicenses } from "../../../../../hooks/machineLicenses/useChangeMachineLicenses";

export type ChangeMachineLicensesFormValueType = {
  transaction_id?: string | null
  language?: string | null;
  email_address?: string | null
};

type ChangeMachineLicensesFormProps = {
  onChangeMachineLicensesCallBackFn: (
    obj: ChangeMachineLicensesFormValueType,
    license:
      | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
      | undefined,

  ) => void;
  licenseFormValues?: ChangeMachineLicensesFormValueType
};

export const ChangeMachineLicensesForm: React.FC<ChangeMachineLicensesFormProps> = ({
  onChangeMachineLicensesCallBackFn,
  licenseFormValues }) => {
  const queryClient = useQueryClient();
  const queryKey = "changelevellicensemanage";
  const changeMachineLicenses = useChangeMachineLicenses();
  const onSubmit = async (
    values: ChangeMachineLicensesFormValueType,
    formikHelpers: FormikHelpers<ChangeMachineLicensesFormValueType>
  ) => {
    await onChangeMachineLicenses(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const createLicenseFormToInitialValues = (
    formvalues: ChangeMachineLicensesFormValueType
  ) => {
    const { transaction_id, email_address, language } = formvalues;

    const initialValues: ChangeMachineLicensesFormValueType = {
      transaction_id: transaction_id,
      language: language ?? "",
      email_address: email_address ?? ""
    };

    return initialValues;
  };

  const initialValues: ChangeMachineLicensesFormValueType = {
    email_address: licenseFormValues?.email_address ?? "",
    transaction_id: licenseFormValues?.transaction_id ?? "",
    language: licenseFormValues?.language ?? "",
  };

  const handleChangeMachineLicenses = async (
    values: ChangeMachineLicensesFormValueType,
    formikHelpers: FormikHelpers<ChangeMachineLicensesFormValueType>,
    options: {}
  ) => {
    //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    let newEntity:
      | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
      | undefined = await changeMachineLicenses({
        transaction_id: values.transaction_id,
        step: 1,
        email_address: values.email_address ?? "",
        language: values.language,
      });
    console.log("new Entity ", newEntity);
    formikHelpers.resetForm({
      values: newEntity
        ? createLicenseFormToInitialValues({
          email_address: newEntity?.email_address ?? "",
          transaction_id: newEntity?.transaction_id ?? "",
          language: newEntity?.language ?? "",
        })
        : createLicenseFormToInitialValues({
          transaction_id: "",
          email_address: "",
          language: "",
        }),
    });
    queryClient.setQueryData(queryKey, newEntity);
    onChangeMachineLicensesCallBackFn(values, newEntity);
  };

  const formSubmitToChangeMachineLicenses = () => {
    return [
      async (
        values: ChangeMachineLicensesFormValueType,
        formikHelpers: FormikHelpers<ChangeMachineLicensesFormValueType>
      ) => {
        return handleChangeMachineLicenses(values, formikHelpers, {});
      },
      {
        translationPrefix: ["licensemanager", "changelevel"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onChangeMachineLicenses = useFormSubmit(
    ...formSubmitToChangeMachineLicenses()
  );

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayChangeMachineLicensesForm />
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
